import { cohesion } from "@redventures/cohesion-utils-react";
import { setPageAction } from "./newrelic";
import waitFor, { WaitForOptions } from "./wait-for";

export const waitForCohesion = (
  options: WaitForOptions = {}
): Promise<void> => {
  return waitFor(() => typeof cohesion === "function", {
    errorMessage: "Cohesion failed to load",
    ...options,
  })
    .then(() => {
      setPageAction("cohesionScriptLoaded");
    })
    .catch((error: unknown) => {
      // Emit explicit failure PageAction for dashboard symmetry with
      // cohesionScriptLoaded. Re-throw so AdobeDataLayer's .catch still
      // fires adobeDataLayerLoadedManually and trackError().
      setPageAction("cohesionScriptFailed");
      throw error;
    });
};
